import { render, staticRenderFns } from "./SolidBackground.vue?vue&type=template&id=f07c74ae&scoped=true&"
import script from "./SolidBackground.vue?vue&type=script&lang=js&"
export * from "./SolidBackground.vue?vue&type=script&lang=js&"
import style0 from "./SolidBackground.vue?vue&type=style&index=0&id=f07c74ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07c74ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
